module.exports = __webpack_public_path__ + "img/lsj3.867c6185.png";